import config from '@/base/config.js';
import axios from 'axios';

const baseUrl = '/api';

export default {
    code: 'code',
    msg: 'msg',
    OK_CODE: 0,
    ERROR_CODE: 101,
    DEL_CODE: 103,
    NO_AUTH: 6,
    NOT_LOGIN_CODE: 100,
    baseUrl,
    showVersion:"",

    debug(...arg) {
        config.isDebug && console.log(...arg);
    },

    saveTokenInfo(res) {
        if (res.hearders && res.headers.authorization) {
            sessionStorage.setItem('login_token', res.headers.authorization);
        }
    },

    gotoLoginPage() {
        sessionStorage.setItem('backLogin', true);
        sessionStorage.removeItem('login_token');
        window.location.reload();
    },

    send(obj, type = 'get') {
        const self = this;

        const temparr = obj.url.split('.');
        if (temparr[temparr.length - 2] == 'local') {
            type = 'get';
        }

        const token = sessionStorage.getItem('login_token') || '';
        const headers = {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json;charset=UTF-8',
                cid: '',
            },
        };
        const promise = new Promise(((resolve, reject) => {
            if (type == 'get') {
                axios.get(baseUrl + obj.url, headers).then((res) => {
                    self.saveTokenInfo(res);

                    switch (res.data[self.code]) {
                        case self.OK_CODE:
                            resolve(res);
                            self.debug('[eBase][send][get][success]');
                            break;
                        case self.NOT_LOGIN_CODE:
                            self.gotoLoginPage();
                            break;
                        case 502: // 操作失败
                        case self.ERROR_CODE:
                        case self.DEL_CODE:
                        case self.NO_AUTH:
                        default:
                            reject(res);
                            self.debug('[eBase][send][get][then]', res[self.msg]);
                            break;
                    } // EOF switch
                }).catch((res) => {
                    reject(res);
                    self.debug('[eBase][send][get][catch]', res[self.msg]);
                }); // EOF axios get
            } else {
                axios.post(baseUrl + obj.url, obj.params, headers).then((res) => {
                    self.saveTokenInfo(res);

                    switch (res.data[self.code]) {
                        case self.OK_CODE:
                            resolve(res);
                            self.debug('[eBase][send][get][success]');
                            break;
                        case self.NOT_LOGIN_CODE:
                            self.gotoLoginPage();
                            break;
                        case 502: // 操作失败
                        case self.ERROR_CODE:
                        case self.DEL_CODE:
                        case self.NO_AUTH:
                        default:
                            reject(res);
                            self.debug('[eBase][send][post][then]', res[self.msg]);
                            break;
                    } // EOF switch
                }).catch((res) => {
                    reject(res);
                    self.debug('[eBase][send][post][catch]', res[self.msg]);
                }); // EOF axios post
            } // EOF else
        })); // EOF new promise

        return promise;
    }, // EOF send
};


// WEBPACK FOOTER //
// ./src/base/eBase.js